import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/caprock/images/minus.svg'
import _imports_1 from '../../assets/caprock/images/plus.svg'
import _imports_2 from '../../assets/caprock/images/close.svg'


const _withScopeId = n => (_pushScopeId("data-v-15fa0e66"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row my-3 justify-content-center" }
const _hoisted_2 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-3" }
const _hoisted_3 = { class: "login-card" }
const _hoisted_4 = { class: "login-body company" }
const _hoisted_5 = { class: "row mt-3" }
const _hoisted_6 = { class: "col-md-12 col-12" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { style: {"color":"grey","font-family":"'Merriweather'"} }
const _hoisted_9 = { class: "col-md-6 col-6" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Name", -1))
const _hoisted_12 = { class: "col-md-6 col-6" }
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Email", -1))
const _hoisted_15 = { class: "col-md-6 col-6" }
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Phone Number", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 col-12 d-flex justify-content-end" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "subBtn btn btn-success btn-mobile mt-3 btn-mobile font-size-15-18"
  }, " Save Director ")
], -1))
const _hoisted_19 = {
  key: 1,
  class: "row my-3 justify-content-center"
}
const _hoisted_20 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-3" }
const _hoisted_21 = { class: "login-card" }
const _hoisted_22 = { class: "login-body company" }
const _hoisted_23 = { class: "row mt-3" }
const _hoisted_24 = { class: "col-md-12 col-12" }
const _hoisted_25 = { class: "form-group" }
const _hoisted_26 = { style: {"color":"grey","font-family":"'Merriweather'"} }
const _hoisted_27 = { class: "col-md-12 col-12 table-responsive" }
const _hoisted_28 = { class: "table table-bordered w-100" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "No"),
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Email"),
    /*#__PURE__*/_createElementVNode("th", null, "Phone No"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Action")
  ])
], -1))
const _hoisted_30 = { class: "text-center" }
const _hoisted_31 = { class: "text-center" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"height":"1.5rem"},
  src: _imports_2
}, null, -1))
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = { key: 0 }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "6",
  class: "text-center"
}, "No records found", -1))
const _hoisted_37 = [
  _hoisted_36
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.directors.length==0 || _ctx.show_form==1)
      ? (_openBlock(), _createBlock(_component_Form, {
          key: 0,
          ref: "director_form",
          id: "director_form",
          method: "POST",
          action: "/",
          class: "my-1 card p-2",
          onSubmit: _ctx.save_director
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("h4", _hoisted_8, [
                            _createTextVNode(" Add Director "),
                            (_ctx.directors.length>0)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  onClick: _cache[0] || (_cache[0] = ($event: any) => (this.show_form=0)),
                                  style: {"float":"right","cursor":"pointer","height":"1.7rem"},
                                  src: _imports_0
                                }))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _hoisted_11,
                          _createVNode(_component_Field, {
                            modelValue: _ctx.form.director_name,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.director_name) = $event)),
                            placeholder: "i.e. Jonaten ",
                            class: "form-control selected-field",
                            name: "director_name",
                            type: "text",
                            rules: _ctx.requiredField
                          }, null, 8, ["modelValue", "rules"]),
                          _createVNode(_component_ErrorMessage, {
                            style: {"color":"#d00000"},
                            name: "director_name"
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _hoisted_14,
                          _createVNode(_component_Field, {
                            modelValue: _ctx.form.director_email,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.director_email) = $event)),
                            placeholder: "i.e. email@address.com  ",
                            class: "form-control selected-field",
                            name: "director_email",
                            type: "text",
                            rules: [_ctx.requiredField,_ctx.validateEmail]
                          }, null, 8, ["modelValue", "rules"]),
                          _createVNode(_component_ErrorMessage, {
                            style: {"color":"#d00000"},
                            name: "director_email"
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _hoisted_17,
                          _createVNode(_component_Field, {
                            modelValue: _ctx.form.director_phone_no,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.director_phone_no) = $event)),
                            placeholder: "i.e. 3539 000556  ",
                            class: "form-control selected-field",
                            name: "director_phone_no",
                            type: "text",
                            rules: [_ctx.requiredField,_ctx.mobileField]
                          }, null, 8, ["modelValue", "rules"]),
                          _createVNode(_component_ErrorMessage, {
                            style: {"color":"#d00000"},
                            name: "director_phone_no"
                          })
                        ])
                      ]),
                      _hoisted_18
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["onSubmit"]))
      : _createCommentVNode("", true),
    (_ctx.directors.length>0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("h4", _hoisted_26, [
                        _createTextVNode(" Company Directors "),
                        _createElementVNode("img", {
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (this.show_form=1)),
                          style: {"float":"right","cursor":"pointer","height":"1.7rem"},
                          src: _imports_1
                        })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("table", _hoisted_28, [
                      _hoisted_29,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.directors, (director, index) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: director.director_id
                          }, [
                            _createElementVNode("td", _hoisted_30, _toDisplayString(index+1), 1),
                            _createElementVNode("td", null, _toDisplayString(director['director_name']), 1),
                            _createElementVNode("td", null, _toDisplayString(director['director_email']), 1),
                            _createElementVNode("td", null, _toDisplayString(director['director_phone_no']), 1),
                            _createElementVNode("td", _hoisted_31, [
                              _createElementVNode("button", {
                                type: "button",
                                onClick: ($event: any) => {_ctx.delete_director(director.director_id);},
                                class: "btn-mobile btn"
                              }, _hoisted_34, 8, _hoisted_32)
                            ])
                          ]))
                        }), 128)),
                        (!_ctx.directors.length)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_35, _hoisted_37))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}